import React, { useState, useEffect } from 'react'
import { AXIOS } from '../api'
import { Link } from 'react-router-dom'
import { useSelector, useDispatch } from 'react-redux'
import Switch from "react-switch"
import { Box, Text, Icons, PictureItem } from './common/Themes'

import { setLoading } from '../redux/actions'

const GestionActivites = () => {

    const dispatch = useDispatch()

    const { activites } = useSelector(state => state.fetch)
    const [activitesStatus, setActivitesStatus] = useState({})
    const [activitesFill, setActivitesFill] = useState([])

    useEffect(() => {
        setActivitesFill(activites)
        let obj = {}
        activites.map(({ aid, status, status_borne }) => obj[aid] = { status, status_borne })
        setActivitesStatus(obj)
    }, [activites, setActivitesFill, setActivitesStatus,])

    const changeStatusHandler = async (aid, status, mode) => {
        try {
            dispatch(setLoading(true))
            await AXIOS.patch(`/api/v1/activites/${aid}`, { [mode]: status })
            dispatch(setLoading(false))
        } catch (error) {
            console.log(error)
        }
    }

    const gestionItem = (aid, classement, status, title, image, color, color1, color2) => {
        return (
            <Box key={aid}>
                <div style={{ margin: '0 1rem', width: '1.3rem' }}></div>
                <PictureItem image={`url(${process.env.REACT_APP_SITE_MARCHAND}${image}), url('/img/default_image.png')`}>&nbsp;</PictureItem>
                <Text color={color1} style={{ width: '14rem' }}>{classement}</Text>
                <Text color={color1}>{title}</Text>
                <div className="gestion__text"></div>
                <div className="gestion__text"></div>
                <div style={{ margin: ' 0 4rem 0 auto', zIndex: '1' }}>
                    <Switch checked={activitesStatus[aid].status} onColor={color2} onChange={() => { onChangeStatus(aid); changeStatusHandler(aid, !activitesStatus[aid].status, 'status'); }} />
                </div>
                <div style={{ margin: ' 0 3rem 0 2rem', zIndex: '1' }}>
                    <Switch checked={activitesStatus[aid].status_borne} onColor={color2} onChange={() => { onChangeStatusBorne(aid); changeStatusHandler(aid, !activitesStatus[aid].status_borne, 'status_borne'); }} />
                </div>
                <div style={{ marginLeft: 'auto' }}>
                    <Link to={`/activite/${aid}`}>
                        <Icons color={color1}>
                            <use xlinkHref="/img/sprite.svg#icon-edit"></use>
                        </Icons>
                    </Link>
                </div>
            </Box>
        );
    }

    const onChangeStatus = aid => {
        setActivitesStatus(current => ({
            ...current,
            [aid]: { status: !activitesStatus[aid].status, status_borne: activitesStatus[aid].status_borne }
        }))
    }

    const onChangeStatusBorne = aid => {
        setActivitesStatus(current => ({
            ...current,
            [aid]: { status: activitesStatus[aid].status, status_borne: !activitesStatus[aid].status_borne }
        }))
    }

    const handleChange = e => setActivitesFill(activites.filter(({ name }) => name?.toLocaleLowerCase().includes(e.target.value?.toLocaleLowerCase())))

    return (
        <>
            <div className="gestion">
                <div className="gestion__header" style={{ marginBottom: '6rem' }}>
                    <h4 className="gestion__title">Gestion activités</h4>

                    <div style={{ marginLeft: 'auto', display: 'flex', position: 'relative' }}>
                        <input name="search" onChange={handleChange} className="gestion__input" placeholder="Rechercher" />
                        <Icons color="#B0BAC9" style={{ margin: '1rem', position: 'absolute', right: '1rem' }}>
                            <use xlinkHref="/img/sprite.svg#icon-search"></use>
                        </Icons>
                    </div>

                </div>
                <div className="gestion__content">
                    <div className="gestion__listheader">
                        <div className="gestion__headerItem" style={{ width: '14.4rem' }}></div>
                        <div className="gestion__headerItem" style={{ width: '14.4rem' }}>Classement</div>
                        <div className="gestion__headerItem">Nom</div>
                        <div className="gestion__headerItem"></div>
                        <div className="gestion__headerItem" style={{ width: '5rem' }}></div>
                        <div className="gestion__headerItem" style={{ width: '14rem' }}>Site marchand</div>
                        <div className="gestion__headerItem" style={{ width: '14.5rem' }}>Borne</div>
                    </div>
                    <div className="gestion__list">
                        {activitesFill.map(({ aid, classement, status, name, image, color, color1, color2 }) => gestionItem(aid, classement, status, name, image, color, color1, color2))}
                    </div>
                </div>
            </div>
        </>
    );
}

export default GestionActivites